import * as ModalTypes from '@components/App/Modal/constants'
import { Comments as BaseComments } from '@components/ArtBoard/Comments'
import { CommentsActions } from '@store/reducers/comments'
import { loginStrategy } from '@storeOld/reducers/shared'
import { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'

import API from '@/api'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import styles from './Comments.module.css'
import { getCommentsByCommentableAndType } from './selectors'

const Comments = ({
  nodeId,
  nodeName,
  onLogin,
  loggedIn,
  onCommit,
  onUpdate,
  userId,
  nodeVariant,
  ...props
}) => {
  const team = useSelector((state) => null)

  useEffect(() => {
    if (team) {
      const teamId = team.id

      API.Team.show(teamId).catch((e) => console.error(e))
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <BaseComments
          {...props}
          nodeId={nodeId}
          loggedIn={loggedIn}
          onLogin={onLogin}
          onCommit={onCommit}
          localStorageKey={`${nodeId}_page`}
          onUpdate={onUpdate}
          type="node"
        />
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth, project, manager }, { commentable }) => ({
  loggedIn: auth.authenticated,
  userId: auth.id,
  comments: getCommentsByCommentableAndType(manager.comments, commentable),
  members: [],
  isOwner: manager.meta.ownerId === auth.id,
})

const mapDispatchToProps = (dispatch, { commentable }) => {
  return {
    onLogin: () =>
      dispatch(loginStrategy({ type: ModalTypes.MODAL_BLOCK_CONTENT_VIEW })),
    onCommit: (payload) => {
      sendGtmEvent(
        GtmTriggerName.PAGE_COMMENT_ADD,
        'Submit comment for page (node)'
      )

      dispatch(
        CommentsActions.create({
          ...payload,
          commentable,
          commentableType: 1,
        })
      )

      return Promise.resolve()
    },
    onUpdate: (payload) => dispatch(CommentsActions.update({ ...payload })),
    onDelete: (id) => dispatch(CommentsActions.delete({ id })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Comments)
